import Clevertap from 'analytics'
import { getCookie, resolveKeysInObjectsArrays, isEmpty, isUserSignedIn, isCtUser } from 'utils/browserHelper'

export const triggerHiFiveClevertap = (payload = {}, eventName = 'Air_UI_Action') => {
    let commonParams = {
        domain: resolveKeysInObjectsArrays(['location', 'hostname'], window),
        platform: 'Desktop'
    }
    if (isUserSignedIn()) {
        const userIdCookie = getCookie('userid')
        const userId = decodeURIComponent(userIdCookie).split('|')[4]
        commonParams['user_id'] = userId
    }
    Clevertap.event(eventName, {
        ...payload,
        ...commonParams
    })
}
